import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const CtaSection = ({
  title = "Ready to move money differently?",
  subtitle = "Build faster. Reach further. Move money with confidence.",
}) => (
  <section className="relative overflow-hidden bg-[#F8FAFC] py-20 md:py-28" data-testid="cta-section">
    <svg className="pointer-events-none absolute inset-0 h-full w-full" viewBox="0 0 1440 400" fill="none" preserveAspectRatio="none" aria-hidden="true">
      <path d="M-40 320 C 300 220 620 360 900 260 C 1100 190 1300 240 1500 160" stroke="#2E7CD6" strokeOpacity="0.14" strokeWidth="1.5" className="sw-flow-line" />
      <path d="M-40 360 C 340 300 660 400 960 320 C 1160 266 1320 300 1500 230" stroke="#1E3A6E" strokeOpacity="0.1" strokeWidth="1.5" className="sw-flow-line" style={{ animationDirection: "reverse" }} />
      <circle cx="900" cy="260" r="5" fill="#2E7CD6" fillOpacity="0.3" />
      <circle cx="300" cy="268" r="5" fill="#1E3A6E" fillOpacity="0.25" />
    </svg>
    <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" aria-hidden="true">
      <img
        src="/banner-globe-africa.webp"
        alt=""
        loading="lazy"
        className="sw-animate-float-slow w-[620px] max-w-none opacity-70 [mask-image:radial-gradient(closest-side,black_45%,transparent_98%)] md:w-[780px]"
      />
    </div>
    <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
      <Reveal>
        <h2 className="font-heading text-4xl font-bold tracking-tight text-[#0F172A] md:text-5xl">{title}</h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-[#334155] md:text-lg">{subtitle}</p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/contact"
            data-testid="cta-get-started"
            className="group flex w-full items-center justify-center gap-2 rounded-full bg-[#1E3A6E] px-8 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#16294e] sm:w-auto"
          >
            Get Started
            <ArrowRight size={16} strokeWidth={2} className="transition-transform duration-200 group-hover:translate-x-0.5" />
          </Link>
          <Link
            to="/contact"
            data-testid="cta-talk-to-sales"
            className="flex w-full items-center justify-center rounded-full border border-[#E2E8F0] bg-white px-8 py-3.5 text-sm font-semibold text-[#0F172A] transition-colors hover:bg-slate-50 sm:w-auto"
          >
            Talk to Sales
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaSection;
